import React from 'react';
import { Table, Tag, Typography } from 'antd';
import { HANDLING_MODE_LABEL, ReceivingException, ReceivingPlanEntry } from '../../types/returnInspection';

const { Text } = Typography;

const MODE_COLOR: Record<ReceivingPlanEntry['mode'], string> = {
  destroy: 'red',
  aiu: 'orange',
  normal: 'green',
  inspect: 'blue',
};

const formatTime = (iso?: string | null) => {
  if (!iso) return '-';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleString('zh-CN', { hour12: false });
};

interface Props {
  exception: ReceivingException;
  unitLabels?: Record<number, string>;
  /** 是否显示确认人（只有仓库端有操作人姓名） */
  showMeta?: boolean;
}

/** 已确认的处理方案（只读）：每一项的实收数量和处理方式，以及谁、什么时候、怎么确认的 */
const ReceivingPlanSummary: React.FC<Props> = ({ exception, unitLabels = {}, showMeta = true }) => (
  <div>
    <Table
      size="small"
      pagination={false}
      rowKey="key"
      dataSource={exception.plan}
      columns={[
        {
          title: '货品',
          key: 'item',
          render: (_: unknown, entry: ReceivingPlanEntry) =>
            entry.source === 'forecast_line' ? (
              <span><Text strong>预报内</Text>　{unitLabels[entry.inventory_unit as number] || entry.description}</span>
            ) : (
              <span>
                <Text strong style={{ color: '#cf1322' }}>预报外</Text>　{entry.description}
                {entry.inventory_unit_barcode ? <Text type="secondary">（指定为 {entry.inventory_unit_barcode}）</Text> : null}
              </span>
            ),
        },
        { title: '实收数量', dataIndex: 'quantity', key: 'quantity', width: 90, align: 'center' as const },
        {
          title: '处理方式',
          key: 'mode',
          width: 220,
          render: (_: unknown, entry: ReceivingPlanEntry) => <Tag color={MODE_COLOR[entry.mode]}>{HANDLING_MODE_LABEL[entry.mode]}</Tag>,
        },
      ]}
    />
    {showMeta && (
      <div style={{ marginTop: 6, fontSize: 12, color: '#8c8c8c' }}>
        {exception.plan_origin === 'customer' ? '由客户确认' : '仓库代客户录入'}
        {exception.plan_confirmed_by_name ? `（${exception.plan_confirmed_by_name}）` : ''}
        ，{formatTime(exception.plan_confirmed_at)}
        {exception.plan_note ? `；备注：${exception.plan_note}` : ''}
        {exception.plan_history.length > 0 ? `；已修改过 ${exception.plan_history.length} 次` : ''}
      </div>
    )}
  </div>
);

export default ReceivingPlanSummary;
